import type { Feature } from './Feature';
import type { SiteWithAccountOrg } from './SiteWithAccountOrg';

import { isAllowedBase } from './isAllowedBase';
import { getAllWithoutGates } from './getAllWithoutGates';

/**
 * Check if a feature can be used by a specific site without checking in gates
 */
export function isAllowedWithoutGates(feature: Feature, site: SiteWithAccountOrg | null): boolean {
  const availableFeatures = getAllWithoutGates(site);
  return isAllowedBase(feature, availableFeatures);
}
